import React, { useState, Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";

// Importing AOS Library 
import AOS from "aos";
import "aos/dist/aos.css";

// Importing Material UI Stuff
import { Container } from "@material-ui/core";
import { ThemeProvider, makeStyles } from "@material-ui/core/styles";
import { darkTheme, createTheme } from "./theme";
import CircularProgress from '@material-ui/core/CircularProgress';

//Importing Components
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import arrowup from "./assets/social-icons/chevron-up.svg";
import BackgroundBlur from "./components/BackgroundBlur";

//Importing Routes
import Routes from "./routes";

const CircleCursor = React.lazy(() => import("./components/CircleCursor"));

function CustomScrollProgress() {
  const [scrollProgress, setScrollProgress] = useState(0);

  const progressStyles = makeStyles({
    root: {
      color: "#5D5FFF",
    },
    scrollupBtn: {
      position: "fixed",
      bottom: "2rem",
      right: "2rem",
      zIndex: 20,
      borderRadius: "50%",
      backgroundColor: "#090B11",
      width: "2.6rem",
      height: "2.6rem",
    },
    arrow: {
      color: "#5D5FFF",
      zIndex: 200,
      position: "absolute",
      top: 7,
      left: 8,
    }
  });

  const progressClasses = progressStyles();


  const progressBar = () => {
    const scrollTotal = document.documentElement.scrollTop;
    const heightWin = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scroll = Math.round(scrollTotal / heightWin * 100);

    setScrollProgress(scroll);
  };

  window.addEventListener("scroll", progressBar);



  return (
    scrollProgress ?
      <div onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className={`${progressClasses.scrollupBtn} hover-detect`}>
        <CircularProgress thickness={2} classes={{
          root: progressClasses.root,
        }} variant="determinate" value={scrollProgress} />
        <img src={arrowup} className={progressClasses.arrow} alt="arrow up icon" />
      </div>
      : null
  )
}

function Content() {

  // initiatlizing AOS
  AOS.init();

  return (
    <>
      <div className="overlay">
        <div className="preloader">
          <svg
            width="484"
            height="118"
            viewBox="0 0 484 118"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            id="logo"
          >
            <path
              d="M13.2356 21.6622C13.2356 16.8871 12.5801 13.376 11.2693 11.1289C9.95852 8.78814 7.33689 7.61777 3.40444 7.61777H2V3.40444H40.2009C59.1141 3.40444 73.4862 7.43052 83.3173 15.4827C93.2421 23.4412 98.2045 34.6767 98.2045 49.1893C98.2045 58.4587 96.0978 66.6513 91.8844 73.7671C87.7647 80.7893 81.5852 86.2667 73.3458 90.1991C65.2 94.1316 55.3689 96.0978 43.8524 96.0978H13.2356V21.6622ZM43.4311 90.48C49.9852 90.48 55.7902 88.8415 60.8462 85.5644C65.9959 82.2874 69.9751 77.5591 72.784 71.3796C75.6865 65.2 77.1378 57.9905 77.1378 49.7511C77.1378 41.6053 75.6865 34.4895 72.784 28.4036C69.9751 22.224 65.9959 17.4489 60.8462 14.0782C55.6966 10.7076 49.7979 9.02222 43.1502 9.02222H42.0267C38.9369 9.02222 36.4557 9.20948 34.5831 9.58399L31.4933 10.0053V89.4969L34.5831 90.0587C36.5493 90.3396 39.0305 90.48 42.0267 90.48H43.4311Z"
              stroke="#5D5FEF"
              strokeWidth="2"
              mask="url(#path-1-outside-1)"
            />
            <path
              d="M115.826 21.6622C115.826 16.8871 115.17 13.376 113.86 11.1289C112.549 8.78814 109.927 7.61777 105.995 7.61777H104.59V3.40444H166.526C174.485 3.40444 178.464 7.14963 178.464 14.64V26.5778H174.251C174.251 20.7727 172.753 16.5126 169.757 13.7973C166.854 11.0821 162.5 9.72445 156.695 9.72445H134.084V44.8356H170.599V51.1556H134.084V89.7778H158.1C163.436 89.7778 167.884 88.6074 171.442 86.2667C175 83.8323 177.949 79.6658 180.29 73.7671L184.082 75.1716L180.009 86.2667C178.792 89.6373 177.341 92.1185 175.655 93.7102C173.97 95.3019 171.348 96.0978 167.79 96.0978H115.826V21.6622Z"
              stroke="#5D5FEF"
              strokeWidth="2"
              mask="url(#path-1-outside-1)"
            />
            <path
              d="M195.965 19.8364C193.811 14.6868 191.658 11.0353 189.504 8.88177C187.444 6.72829 184.963 5.46429 182.061 5.08978V2.28088L187.959 2C194.139 2 199.569 3.17037 204.251 5.51111C208.932 7.85185 212.771 12.627 215.767 19.8364L237.958 72.3627L267.591 3.40444H274.754L234.306 97.5022H228.688L195.965 19.8364Z"
              stroke="#5D5FEF"
              strokeWidth="2"
              mask="url(#path-1-outside-1)"
            />
            <path
              d="M354.494 97.5022C349.344 97.5022 344.662 96.0042 340.449 93.008C336.236 89.9182 331.835 84.6281 327.247 77.1378L313.203 53.6836H307.585V96.0978H289.187V21.6622C289.187 16.8871 288.532 13.376 287.221 11.1289C285.91 8.78814 283.288 7.61777 279.356 7.61777H277.951V3.40444H316.714C326.452 3.40444 335.206 5.1834 342.977 8.74133C350.748 12.2993 354.634 19.1342 354.634 29.2462C354.634 40.9499 347.05 48.7212 331.882 52.56L346.629 77.1378C352.153 86.4071 357.958 91.5567 364.044 92.5867V96.0978C363.295 96.4723 361.937 96.8 359.971 97.0809C358.005 97.3618 356.179 97.5022 354.494 97.5022ZM316.012 48.0658C321.255 48.0658 325.703 46.5209 329.354 43.4311C333.099 40.2477 334.972 35.2853 334.972 28.544C334.972 21.8963 333.146 16.9807 329.495 13.7973C325.843 10.6139 321.583 9.02222 316.714 9.02222C313.999 9.02222 311.892 9.20948 310.394 9.58399L307.585 10.0053V48.0658H316.012Z"
              stroke="#5D5FEF"
              strokeWidth="2"
              mask="url(#path-1-outside-1)"
            />
            <path
              d="M450.587 96.6596C444.689 96.6596 439.352 95.4424 434.577 93.008C429.801 90.48 425.916 85.6113 422.92 78.4018L419.689 70.5369H382.331L370.815 96.0978H363.512L404.943 3.40444H411.263L442.722 78.4018C446.28 87.1093 451.149 91.7908 457.329 92.4462V95.9573C455.643 96.4255 453.396 96.6596 450.587 96.6596ZM385.281 64.2169H417.021L401.572 27.5609L385.281 64.2169Z"
              stroke="#5D5FEF"
              strokeWidth="2"
              mask="url(#path-1-outside-1)"
            />
            <path
              d="M450.652 111.125C455.146 110.564 458.423 108.316 460.483 104.384C462.637 100.545 463.713 93.8975 463.713 84.4409V3.40444H481.971V84.4409C481.971 92.7739 481.082 99.0939 479.303 103.401C477.617 107.801 474.574 110.891 470.174 112.67C465.773 114.449 459.266 115.339 450.652 115.339V111.125Z"
              stroke="#5D5FEF"
              strokeWidth="2"
              mask="url(#path-1-outside-1)"
            />
          </svg>
          <div className="backgroundblur1"></div>
          <div className="backgroundblur2"></div>
        </div>
      </div>

      <section id="home" className="content" data-barba="wrapper">
        <div className="container">
          <Router>
            <NavBar />
            <div style={{overflowX: "hidden"}}>
              <Container style={{ maxWidth: "1200px"}}>
                <Routes />
              </Container>
            </div>
            <Footer />
            <BackgroundBlur />
          </Router>
        </div>
      </section>
    </>
  );
}

function App() {
  const [theme] = useState(createTheme(darkTheme));

  return (
    <ThemeProvider theme={theme}>
      <Content />
      <Suspense fallback={<div>Loading ... </div>}>
        <CircleCursor safeBoundaryX="0" initial={{ circleSize: '30px', dotSize: '6px', color: '#B6CFFF' }} hover={{ circleSize: '50px', dotSize: '0px', color: '#B6CFFF' }} />
      </Suspense>
      <CustomScrollProgress />
    </ThemeProvider>
  );
}

export default App;
